<router-outlet />
@if (loadingService.isLoading()) {
  <app-loading />
}
